import type { ApolloClient } from '@apollo/client';
import { gql } from '@apollo/client';
import { Delta } from 'quill/core';
import POST_CONTENT_FRAGMENT from '../../graphql/fragments/PostContent';
import type {
  FetchPostAnchorTitlePostQuery,
  FetchPostAnchorTitlePostQueryVariables,
} from '../../graphql/generated/graphqlTypes';
import Header from '../formats/Header';
import { parsePostMentionId } from './matchMention';

const POST_CONTENT_QUERY = gql`
  query fetchPostAnchorTitlePost($id: ID!) {
    post(id: $id) {
      id
      ...PostContent
    }
  }
  ${POST_CONTENT_FRAGMENT}
`;

const getHeaderTitle = (content: Delta, anchor: string): string | null => {
  const anchorHeaderId = Header.parseHeaderId(anchor);
  let title: string | null = null;
  if (anchorHeaderId) {
    new Delta(content).eachLine((line, attributes) => {
      if (attributes.header && attributes['header-id'] === anchorHeaderId) {
        title = line
          .map((op) => (typeof op.insert === 'string' ? op.insert : ''))
          .join('');
        return false;
      }
      return true;
    });
  }
  return title;
};

async function fetchPostAnchorTitle(
  apollo: ApolloClient<unknown>,
  postMentionId: string,
) {
  const { id, anchor } = parsePostMentionId(postMentionId);
  if (!anchor) return null;

  let content;
  try {
    const { data } = await apollo.query<
      FetchPostAnchorTitlePostQuery,
      FetchPostAnchorTitlePostQueryVariables
    >({
      query: POST_CONTENT_QUERY,
      variables: { id },
      fetchPolicy: 'network-only',
    });
    content = data?.post?.content;
  } catch (err) {
    return null;
  }

  const headerTitle = content && getHeaderTitle(new Delta(content), anchor);
  return typeof headerTitle === 'string' && headerTitle.trim()
    ? headerTitle
    : null;
}

export default fetchPostAnchorTitle;
